import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { ISaveDraftButtonProps } from './types';

export const SaveDraftButton = (props: ISaveDraftButtonProps) => {
  const { isDisabled, isPending, onClick } = props;

  return (
    <Button
      data-name="SaveDraftButton"
      type="button"
      disabled={isDisabled}
      loading={isPending}
      onClick={onClick}
      theme="fill_secondary"
      fullWidth
    >
      Сохранить черновик
    </Button>
  );
};
